import { Injectable } from "@angular/core";
import { SignUp } from "src/app/models/User/SignUp.model";
import { SignUpResponse } from "src/app/models/User/SignupResponse.model";
import { ApiService, ErrorResponse } from "../api/api.service";

export class RegisterError extends Error {
    constructor(message: string, public readonly property?: string) {
        super(message);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RegisterService {

    constructor(private api: ApiService){
    }

    public async emailExists(email: string): Promise<boolean> {
        try {
            const r = await this.api.get<boolean>('/sign-up/valid-email', {Email: email})
            if(r.success) {
                return r.data
            }
            return false
        } catch(err) {
            throw(err);
        }
    }

    public async register(user: SignUp): Promise<boolean> {
        try {
            const r = await this.api.post<boolean>('/sign-up', user)
            if(r.success) {
                return r.data
            } else {
                const { message, property } = this.buildErrorMessage(r);
                throw new RegisterError(message, property);
            }
        } catch(err) {
            throw(err);
        }
    }

    private buildErrorMessage(r: { message?: string; data?: ErrorResponse[] }): { message: string; property?: string } {
        const errors = (r.data ?? []).filter(e => !!e?.message && e.message.trim().length > 0);

        if (errors.length > 0) {
            return {
                message: errors.map(e => e.message).join('\n'),
                property: errors.length === 1 ? errors[0].property : undefined
            };
        }
        if (r.message) return { message: r.message };
        return { message: 'Não foi possível realizar o cadastro. Verifique se todos os campos foram preenchidos corretamente e tente novamente mais tarde' };
    }

    public async documentExists(document: string): Promise<boolean> {
        try {
            const r = await this.api.get<boolean>('/sign-up/valid-document', {Document: document})
            if(r.success) {
                return r.data
            } 
            return false
        } catch(err) {
            throw(err);
        }
    }
}